import SEO from "edu_lms/components/Seo";
import { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Loading from "edu_lms_v2/components/Loading";
import {
  DEFAULT_GRADE_ID,
  DEFAULT_SUBJECT_ID,
  TYPE_MOCK_TEST,
} from "./constant";
import { getListExam } from "edu_lms/services/readingBook";
import QuestionLibraryDetail from "./QuestionLibraryDetail";
import { pages } from "edu_lms/components/Seo/meta";
import { ROUTE_PATH_V3_STUDENT_MOCK_TEST } from "consts/routePaths";
import { setEventGTM } from "edu_lms/constants/googleTagManager";
import { OPEN_TEST } from "edu_lms/constants/eventNameGTM";
import useScrollToTop from "edu_lms_v2/services/useScrollToTop";
import "./styles.scss";
import GradeFilter from "../../../components/GradeFilter";
import SubjectFilter from "../../../components/SubjectFilter";
import { useAppStore } from "../../../stores/appStore";
import { useDeKiemTraStore } from "../../../stores/dekiemtraStore";
import {  DEFAULT_SUBJECT_SLUG_BY_GRADE_2 } from "../../../consts/book";
import _ from "lodash";
import { useSelector } from "react-redux";

export default function MockTestV2() {
  const [loading, setLoading] = useState(false);
  const [questionDetail, setQuestionDetail] = useState([]);
  const history = useHistory();
  const params = useParams();
	const grades = useAppStore((state) => state.grades);
	const subjects = useAppStore((state) => state.subjects);
	const fetchGrades = useAppStore((state) => state.fetchGrades);
	const fetchSubjects = useAppStore((state) => state.fetchSubjects);
	const gradeSubjects = useDeKiemTraStore((state) => state.gradeSubjects);
	
	const fetchGradeSubjects = useDeKiemTraStore(
		(state) => state.fetchGradeSubjects);
	const gradeId = useAppStore((state) => state.gradeId);
	const subjectId = useAppStore((state) => state.subjectId);
	const currentGrade = grades.find((grade) => grade.id === gradeId);
	const currentSubject = subjects.find((subject) => subject.id === subjectId);
	const setSubjectId = useAppStore((state) => state.setSubjectId);
	const { list } = useSelector((state) => state.mockTestReducers);
	
	const [grade, setGrade] = useState({
    id: [DEFAULT_GRADE_ID],
    currentGrade: "Lớp 1",
    listGrade: [],
  });
  const [subject, setSubject] = useState({
    id: [DEFAULT_SUBJECT_ID],
    currentSubject: "Tiếng Việt",
    listSubject: [],
  });

  const handleShowQuestion = (gradeId, subjectId) => {
    setQuestionDetail([]);
    if (gradeId && subjectId) {
      setLoading(true);
      getListExam({ type: TYPE_MOCK_TEST, gradeId, subjectId })
        .then((res) => {
	        setQuestionDetail(res.data.data)
        })
        .catch((e) => console.log(console.log(e)))
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleSortAsc = (data, sortArray, key) => {
    return data.sort((a, b) => {
      if (!sortArray) return [];

      return (
        sortArray.findIndex((id) => id === a[key]) -
        sortArray.findIndex((id) => id === b[key])
      );
    });
  };
  
  
	useEffect (() => {
		if (!Object.keys (grades).length) {
			fetchGrades ();
		}
		if(!Object.keys(subjects).length) {
			fetchSubjects();
		}
	}, []);
	useEffect(() => {
		fetchGradeSubjects();
	}, [currentGrade?.parent_id, fetchGradeSubjects]);
	useEffect(() => {
		if (currentSubject?.slug && currentGrade?.slug) {
			window.history.replaceState(null, '', `${ROUTE_PATH_V3_STUDENT_MOCK_TEST}${currentSubject?.slug}/${currentGrade?.slug}/`);
		}
	}, [currentGrade?.slug, currentSubject?.slug]);
	
	useEffect(() => {
		const setDefaultSubject = () => {
			// Dang co mot table manage viec display grade, subject nen phai lay o 2 nguon moi du data
			// TODO: toi uu data management cho viec hien thi grade, subject tren caca page
			const _currentGrade = gradeSubjects?.grades?.find(
				(grade) => grade.grade_id === gradeId
			);
			if (_currentGrade) {
				const currentGrade = grades.find((grade) => grade.id === gradeId);
				// 1. Check subject value from store
				if (subjectId) {
					const currentSubjectFromStore = subjects.find(
						(subject) => subject.id === subjectId
					);
					if (
						currentSubjectFromStore &&
						_currentGrade?.has_subject_ids?.includes(currentSubjectFromStore.id)
					) {
						return;
					}
				}
				// 2. Check subject value from url params
				const urlParamSubject = params?.subject;
				const currentSubjectFromUrlParams = subjects.find(
					(subject) =>
						subject.slug === urlParamSubject &&
						subject.grade_id === currentGrade?.parent_id
				);
				if (
					currentSubjectFromUrlParams &&
					_currentGrade?.has_subject_ids?.includes(
						currentSubjectFromUrlParams.id
					)
				) {
					setSubjectId(currentSubjectFromUrlParams.id);
					return;
				}
				// 3. Check default subject value
				console.log(currentGrade)
				const defaultSubjectSlug =
					      DEFAULT_SUBJECT_SLUG_BY_GRADE_2[currentGrade?.id];
				if (defaultSubjectSlug) {
					const defaultSubject = subjects.find(
						(subject) =>
							subject.slug === defaultSubjectSlug &&
							subject.grade_id === currentGrade?.parent_id
					);
					if (
						defaultSubject &&
						_currentGrade?.has_subject_ids?.includes(defaultSubject.id)
					) {
						setSubjectId(defaultSubject.id);
						return;
					}
				}
				const filteredSubjects = subjects.filter((subject) =>
					_currentGrade?.has_subject_ids?.includes(subject.id)
				);
				// 4. Check subject value from the first item of subject list
				const firstSubject = _.get(filteredSubjects, "1");
				if (firstSubject) {
					setSubjectId(firstSubject.id);
				}
			}
		};
		
		setDefaultSubject();
	}, [gradeId, gradeSubjects?.grades, grades, params?.subject]);
	
	useEffect(() => {
		const _currentGrade = gradeSubjects?.grades?.find(
			(grade) => grade.grade_id === gradeId
		);
		
		if(_currentGrade) {
			setGrade({
				id: [currentGrade.id],
				currentGrade: currentGrade.name,
				listGrade: grades,
			})
			setSubject({
				id: [currentSubject.id],
				currentSubject: currentSubject.title,
				listSubject: subjects,
			})
			list.gradeId = currentGrade.id;
			list.subjectId = currentSubject.id;
			
			handleShowQuestion(gradeId, subjectId);
			
		}
	}, [gradeId, subjectId]);

  function setTitleExam(id, title) {
    const storageKey = "title_exams";
    const existingData = JSON.parse(localStorage.getItem(storageKey)) || {};
    existingData[id] = title;
    localStorage.setItem(storageKey, JSON.stringify(existingData));
  }

  const handleShowExam = ({ id, title }) => {
    history.push(`${ROUTE_PATH_V3_STUDENT_MOCK_TEST}${id}`);
    setTitleExam(id, title);
    setEventGTM({
      event: OPEN_TEST,
      test_name: title,
      test_grade: grade.currentGrade,
      test_subject: subject.currentSubject,
    });
  };

  useScrollToTop();

  return (
    <main id="test-preparation">
      <SEO data={pages.mock_test} />
      <div className="hoc10-breadcrumb bg-gr">
        <div className="container">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={""}>Trang chủ</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Đề kiểm tra
            </li>
          </ul>
        </div>
      </div>
      <div className="hoc10-search bg-gr">
        <div className="header pr">
          <h1 className="title d-flex justify-content-center">Đề kiểm tra</h1>
          <p className="txt-5 mb-2">
            Đề kiểm tra - tập hợp những câu hỏi do đội ngũ giáo viên giỏi, nhiều
            năm kinh nghiệm tại Hoc10 biên soạn, sắp xếp theo lộ trình học, giúp
            củng cố kiến thức cho học sinh. Học sinh có thể làm trực tuyến, biết
            kết quả chi tiết từng câu hỏi, xem được điểm số qua từng lần luyện
            tập để theo dõi được sự tiến bộ. Hoc10 hy vọng phần ôn luyện này sẽ
            giúp học sinh tối ưu thời gian để đạt được kết quả cao nhất.
          </p>
        </div>
      </div>
      <div className="hoc10-search-result">
	      <div className="container">
		      <div className="filter filter-horizontal mt-3 mb-4 p-0">
			      <GradeFilter
				      direction="horizontal"
			      />
		      </div>
		      
		      <div className="row">
			      <div className="col-lg-3 col-md-4">
				      <div className="filter">
					      <GradeFilter
					      />
					      <SubjectFilter
						      page={ROUTE_PATH_V3_STUDENT_MOCK_TEST}
					      />
				      </div>
			      </div>
			      {!loading ? (
				      <QuestionLibraryDetail
					      questionDetail={questionDetail}
					      handleShowExam={handleShowExam}
					      listGrade={grade.listGrade}
					      listSubject={subject.listSubject}
				      />
			      ) : (
				      <div className="col-lg-9 col-md-8 d-flex justify-content-center">
					      <Loading />
				      </div>
			      )}
		      </div>
	      </div>
      </div>
    </main>
  );
}
